import { render, staticRenderFns } from "./DashModal.vue?vue&type=template&id=2575f657&scoped=true&"
import script from "./DashModal.vue?vue&type=script&lang=js&"
export * from "./DashModal.vue?vue&type=script&lang=js&"
import style0 from "./DashModal.vue?vue&type=style&index=0&id=2575f657&prod&scoped=true&lang=scss&"
import style1 from "./DashModal.vue?vue&type=style&index=1&id=2575f657&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2575f657",
  null
  
)

export default component.exports